<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <addinvite ref="aInvite" v-if="IsAdmin===true" :poolID="PoolID" :groupID="GroupID"></addinvite>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"
  import addinvite from "../../components/AddInvite.vue"

  export default {
    name: 'PoolTags',
    components: {acheader,acfooter,groupsidebar,addinvite},
    data() {
      return {
        IsAdmin:false,
        GroupID:null,
        PoolID:null
      }
    },

    mounted() {
      this.doPage().then(r=>{
        this.bootstrapGroup(this.$route.params.id);
        this.GroupID=this.sdata.activegroup.LicensePoolGroupID;
        this.PoolID=this.sdata.activegroup.LicensePoolID;
        this.IsAdmin=this.sdata.activegroup.IsAdmin;
      });
    }
  }
</script>
